module.exports = __webpack_public_path__ + "static/media/bonus-room.2ad13b38.svg";